import React from 'react';
import { makeStyles } from '@material-ui/core';
import { ReactComponent as Icon } from '#web-components/assets/icons/search.svg';

import styles from './SearchIcon.styles';

const useStyles = makeStyles(styles, { name: 'SearchIcon' });

export default function SearchIcon() {
  const classes = useStyles();
  return (
    <span className={classes.icon}>
      <Icon />
    </span>
  );
}
